import { Reducer } from 'redux';
import { Tenant } from "models/Tenant";
import { ITenantActions, TenantActionType } from "redux/actions/settings/TenantActions";
import { SubscriptionActionType } from "redux/actions/settings/SubscriptionActions";

export const tenantsReducer: Reducer<Tenant[] | null, ITenantActions> =
    (state = null, action) => {
        switch (action.type) {
            case TenantActionType.FETCH_TENANTS_SUCCESS:
                return action.returnPayload as Tenant[];
            case SubscriptionActionType.SET_TENANTPLAN_SUCCESS:
                {
                    const updated = action.returnPayload as unknown as Tenant;
                    return state?.map(t => t.id === updated.id ? updated : t) ?? state;
                }
            default:
                return state;
        }
    };

export const currentTenantReducer: Reducer<Tenant | null, ITenantActions> =
    (state = null, action) => {
        switch (action.type) {
            case TenantActionType.FETCH_CURRENTTENANT_SUCCESS:
            case TenantActionType.EDIT_CURRENTTENANT_SUCCESS:
                return action.returnPayload as Tenant;
            default:
                return state;
        }
    };
